/*
 * @Author: Asadhcj asadhcj@163.com
 * @Date: 2025-07-25 10:41:06
 * @LastEditors: Asadhcj asadhcj@163.com
 * @LastEditTime: 2025-07-25 14:21:49
 * @FilePath: \betdoce-web\src\utils\format.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * 格式化工具类
 */

import moment from "moment";

// 获取巴西时间戳
export function datetimeDefaultFormate(dateTime: string,endTime?: boolean) {
  const timeStr =endTime? dateTime.replace("00:00:00","23:59:59"):dateTime;
  const [datePart, timePart] = timeStr.split(" ");
  const [year, month, day] = datePart.split("-").map(Number);
  const [hours, minutes, seconds] = timePart.split(":").map(Number);
  // 创建 UTC-3 时间的 Date 对象（月份从 0 开始，故 7 月为 6）
  const date = new Date(
    Date.UTC(year, month - 1, day, hours + 3, minutes, seconds),
  );
  // 获取时间戳（毫秒）
  const timestamp = date.getTime()/1;
  return timestamp;
}
/**
 * 获取巴西时间的辅助函数
 * @returns 巴西时间的Date对象
 */
export const getBrazilTime = (): Date => {
  return new Date(
    formatDateTime(
      new Date()
        .toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo" })
        .replace(",", "")
    )
  );
};

/**
 * 将日期字符串转换为巴西时间的Date对象
 * @param dateString 日期字符串或时间戳
 * @returns 巴西时间的Date对象
 */
export const getBrazilDate = (dateString: string | number): Date => {
  const date = new Date(dateString);
  // 将UTC时间转换为巴西时间
  const brazilTime = new Date(
    formatDateTime(
      date
        .toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo" })
        .replace(",", "")
    )
  );
  return brazilTime;
};

/**
 * 格式化日期为 YYYY-MM-DD hh:mm:ss 格式
 * @param date Date对象或日期字符串
 * @returns 格式化后的日期字符串
 */
export const formatDateTime = (date: Date | string): string => {
  let dateObj: Date;

  if (typeof date === "string") {
    // 处理 DD/MM/YYYY hh:mm:ss 格式
    if (date.includes("/")) {
      const [datePart, timePart] = date.split(" ");
      const [day, month, year] = datePart.split("/");
      dateObj = new Date(
        `${year}-${month}-${day}${timePart ? ` ${timePart}` : ""}`
      );
    } else {
      dateObj = new Date(date);
    }
  } else {
    dateObj = date;
  }
  
  return moment(dateObj).format("YYYY-MM-DD HH:mm:ss");
};
